import {Component, OnInit} from '@angular/core';
import {SharedService} from '../../../../services/shared.service';
import {Router} from '@angular/router';
import {OrderService} from '../../../../services/order.service';
import {STATE_SHORT_HASH} from '../../../../global';
import {MatDialog, MatDialogConfig} from '@angular/material';
import {OutOfDeliveryComponent} from '../../../../components/out-of-delivery/out-of-delivery.component';
import {LocationModel} from '../../../../models/location.model';

@Component({
  selector: 'app-location',
  templateUrl: './location.component.html',
  styleUrls: ['./location.component.scss']
})
export class LocationComponent implements OnInit {
  geometry = {
    lat: 25.8441213,
    lng: -80.1819158
  };
  currentGeometry = {
    lat: 25.8441213,
    lng: -80.1819158
  };//Store center when user moves map
  currentZoom: number = 11; //Store zoom changed by user
  marker: any;
  mapZoom: number = 11;
  searchText: string;
  selectedLocation: LocationModel;
  states = STATE_SHORT_HASH;

  constructor(private shared: SharedService,
              private router: Router,
              private orderService: OrderService,
              private dialog: MatDialog) {
    this.shared.sendEvent({type: 'request_step', data: {step: 3, name: 'REQUEST.LOCATION.NAME'}});
    if (this.shared.getStep() != 'location') this.router.navigate(['account', 'request', 'fuel']);
  }

  ngOnInit() {
    if (window.navigator.geolocation) {
      window.navigator.geolocation.getCurrentPosition((position) => {
        if (position) {
          if (position.coords.accuracy <= 40) {
            let latLng = position.coords.latitude + ',' + position.coords.longitude;
            if (!this.searchText) this.searchLocation({latlng: latLng});
          }
          if (position.coords.accuracy > 40 && position.coords.accuracy < 200) {
            setTimeout(() => {
              this.geometry = {
                lat: position.coords.latitude,
                lng: position.coords.longitude
              };
              this.mapZoom = 18;
            }, 100);
          }
        }
      });
    }
  }

  submitStep() {
    this.orderService.getCoverage()
      .then(res => {
        let state = this.states[this.selectedLocation.state];
        let county = this.selectedLocation.county.split(' County')[0];
        if (res[state] && res[state].indexOf(county) != -1) {
          this.shared.updateOrder({specs: {location: this.selectedLocation}}, 'results');
          return this.router.navigate(['account', 'request', 'results']);
        } else {
          let dialogConfig = new MatDialogConfig();
          dialogConfig.autoFocus = true;
          dialogConfig.disableClose = true;
          let dialog = this.dialog.open(OutOfDeliveryComponent);
          dialog.afterClosed().toPromise()
            .then(_ => {
              this.searchText = null;
              this.selectedLocation = null;
              this.geometry = {
                lat: 25.8441213,
                lng: -80.1819158
              };
              this.mapZoom = 11;
            });
        }
      });
  }

  searchLocation(params) {
    let location: any = {};
    this.selectedLocation = null;
    let locationComponent = {
      'street_number': 'streetNumber',
      'route': 'route',
      'locality': 'city',
      'administrative_area_level_2': 'county',
      'administrative_area_level_1': 'state',
      'country': 'country',
      'postal_code': 'postalCode'
    };
    this.shared.addressSearch(params)
      .then(res => {
        let data = res['results'][0];
        if (data) {
          this.geometry = this.currentGeometry;
          this.mapZoom = this.currentZoom;
          let components = data['address_components'];
          components.forEach(component => {
            if (locationComponent[component['types'][0]]) location[locationComponent[component['types'][0]]] = component['short_name'];
          });
          this.selectedLocation = new LocationModel(location);
          if (this.selectedLocation.valid) {
            setTimeout(() => {
              this.geometry = data.geometry.location;
            }, 100);
            setTimeout(() => {
              this.mapZoom = 18;
              this.marker = data.geometry.location;
            }, 100);
            this.searchText = this.selectedLocation.fullAddress;
          } else {
            this.selectedLocation = null;
            this.searchText = null;
            if (!params['latlng']) this.shared.openErrorDialog({title: 'Error', body: 'Address is incomplete or invalid.'});
          }
        } else {
          if (!params['latlng']) this.shared.openErrorDialog({title: 'Error', body: 'Address is incomplete or invalid..'});
        }

      })
      .catch(err => {
        console.log(err);
      });
  }

  zoomChanged(zoom) {
    this.currentZoom = zoom;
  }

  centerChange(geo) {
    this.currentGeometry = geo;
  }

  mapClick(event) {
    let latlng = event.coords.lat + ',' + event.coords.lng;
    this.searchLocation({latlng: latlng});
  }
}
